import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { toAbsoluteUrl } from "../toAbsoluteUrl";

const FileUpload = (props) => {
  const [uploadedFile, setUploadedFile] = useState(props.uploadedFile);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(props.setUploadedFileDone);

  const { getRootProps, getInputProps } = useDropzone({
    accept: [".xls", ".xlsx"],
    multiple: false,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        console.log("acceptedFiles", acceptedFiles);

        setUploadedFile(acceptedFiles[0]);
        props.setUploadedFile(acceptedFiles[0]);
        handleFileUpload(acceptedFiles[0]);
      }
    },
    // onDropRejected: (rejectedFiles) => {
    //   props.errorMessage("Please upload a valid Excel file (.xls or .xlsx).");
    //   console.log("rejectedFiles", rejectedFiles);
    // },
  });

  const handleFileUpload = (file) => {
    // Simulate file upload and update progress
    const fakeUpload = setInterval(() => {
      setUploadProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(fakeUpload);
          setUploadComplete(true);
          return 100;
        }
        return prevProgress + 10;
      });
    }, 500);
  };

  useEffect(() => {
    if (uploadComplete) {
      props.setUploadedFileDone(true);
    }
  }, [uploadComplete]);

  return (
    <div>
      {uploadedFile ? (
        <></>
      ) : (
        <a className="download-template" href="https://dev22.hoja-crm.com/upload/uploadExample1.xlsx">
          <p>Download Template</p>
          <img
          className="notDark"
            src={toAbsoluteUrl("/media/images/download.svg")}
            alt="upload-icon"
          />
            <img
            className="darkMode"
            src={toAbsoluteUrl("/media/images/download-dark.svg")}
            alt="upload-icon"
          />
        </a>
      )}
      <div className="upload-div-style" {...getRootProps()}>
        {uploadedFile ? (
          <div className="file-upload-bar">
            <div style={{ width: 52 }}>
              <CircularProgressbar
                value={uploadProgress}
                text={`${uploadProgress}%`}
                styles={buildStyles({
                  textSize: "18px",
                  pathColor: "#0C838F",
                  textColor: "#0C838F",
                  trailColor: "#DAF9FB",
                })}
              />
            </div>
            <p>Uploading File...</p>
          </div>
        ) : (
          <div>
            <div className="file-upload-bar">
              <img
              className="notDark"
                src={toAbsoluteUrl("/media/images/upload-icon.svg")}
                alt="upload-icon"
              />
               <img
               className="darkMode"
                src={toAbsoluteUrl("/media/images/upload-icon-dark.svg")}
                alt="upload-icon"
              />
              <span>Drag and drop, or upload from device</span>
              <input {...getInputProps()} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
